import FacetedSearchOpenSearch from "../FacetedSearchOpenSearch";

function traits(commands) {
  const {configure, exportConfig, importConfig} = commands;
  const commandID = (val) => `cmd:${val}`.toLowerCase();
  return [
    {
      id: commandID(configure),
      type: 'run-command',
      buttonLabel: 'Configure',
      commandName: configure
    }, {
      id: commandID(exportConfig),
      type: 'run-command',
      buttonLabel: 'Export configuration',
      commandName: exportConfig
    }, {
      id: commandID(importConfig),
      type: 'run-command',
      buttonLabel: 'Import configuration',
      commandName: importConfig
    }
  ];
}

function componentDefinition(editor, options) {
  const {componentType, componentName} = options;
  return {
    extend: 'react-component',
    model: {
      defaults: {
        'custom-name': componentName,
        component: FacetedSearchOpenSearch,
        traits: traits(options.commands),
      },
    },
    isComponent: el => el.tagName === componentType.toUpperCase()
  }
}

export default function (editor, options = {}) {
  editor.Components.addType(options.componentType, componentDefinition(editor, options));
}
